const TOOLTIP_EDGE_BUFFER = 16;
const WRAPPER_HEIGHT_BUFFER = 20;

export default {
  data() {
    return {
      hasDropdownOpen: false,
      tooltipObserver: undefined,
    };
  },

  mounted() {
    if (this.hasDropdownHeaders) {
      document.addEventListener('click', this.expandTableWrapperHeight);
    }
    if (this.hasTooltipHeaders && this.$refs.mainScroll) {
      const observer = new MutationObserver(() => this.expandTableWrapperHeight());
      observer.observe(this.$refs.mainScroll, { attributes: true, attributeFilter: ['class'], subtree: true });
      this.tooltipObserver = observer;
    }
  },

  beforeUnmount() {
    if (this.hasDropdownHeaders) {
      document.removeEventListener('click', this.expandTableWrapperHeight);
    }
    if (this.tooltipObserver) {
      this.tooltipObserver.disconnect();
      this.tooltipObserver = undefined;
    }
  },

  computed: {
    headerList() {
      if (this.headers == null) return [];
      return Array.isArray(this.headers) ? this.headers : Object.values(this.headers);
    },

    hasDropdownHeaders() {
      return this.headerList.some(
        header => header?.hasDropdown || header?.hasMultiSelectDropdown || header?.type === 'dropdown',
      );
    },

    hasTooltipHeaders() {
      return this.headerList.some(header => header?.options?.tooltip);
    },
  },

  methods: {
    expandTableWrapperHeight(event) {
      if (event) {
        const isDropdownButtonClick = event.target.closest('.k-search-dropdown-button');
        const isInsideDropdownClick = event.target.closest('.k-search-dropdown-adv-content');
        if ((!isDropdownButtonClick && !this.hasDropdownOpen) || (isInsideDropdownClick && this.hasDropdownOpen)) {
          return;
        }
      }
      this.$nextTick(() => {
        const kTableWrapper = this.$refs.mainScroll;
        if (!kTableWrapper) return;

        const visibleDropdown = [...kTableWrapper.querySelectorAll('.k-search-dropdown-adv-content')].find(d => window.getComputedStyle(d).display !== 'none');
        this.hasDropdownOpen = !!visibleDropdown;

        const visibleTooltips = this.hasTooltipHeaders ? [...kTableWrapper.querySelectorAll('.tooltip-box.is-visible .tooltip')] : [];

        kTableWrapper.style.minHeight = '';
        if (!visibleDropdown && !visibleTooltips.length) return;

        const wrapperRect = kTableWrapper.getBoundingClientRect();
        let contentBottom = visibleDropdown?.getBoundingClientRect().bottom ?? 0;

        visibleTooltips.forEach(tooltip => {
          const tooltipStyle = tooltip.style;
          tooltipStyle.marginLeft = '';
          const tooltipRect = tooltip.getBoundingClientRect();
          contentBottom = Math.max(contentBottom, tooltipRect.bottom);
          const overflowRight = tooltipRect.right - wrapperRect.right;
          if (overflowRight > 0) {
            tooltipStyle.marginLeft = `-${overflowRight + TOOLTIP_EDGE_BUFFER}px`;
          }
        });

        const extension = contentBottom - wrapperRect.bottom;
        if (extension > 0) {
          kTableWrapper.style.minHeight = `${kTableWrapper.offsetHeight + extension + WRAPPER_HEIGHT_BUFFER}px`;
        }
      });
    },
  },
};
